import { useEffect } from "react";
import UserManagementComponent from "../components/user-management/user-management.component";
import { useAuth } from "../utility/use-auth";
import { useNavigate } from "react-router-dom";

const UserManagement = () => {

    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!user || user.role !== "Admin" && user.role !== "Super Admin") {
            navigate("/not-found");
        }
    }, [user, navigate]);
    return (
        <>
            {
                user && (user.role == "Admin" || user.role == "Super Admin") &&
                <UserManagementComponent></UserManagementComponent>
            }

        </>
    )
}

export default UserManagement;